// components
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';

// mui
import { Stack, Typography } from '@mui/material';

interface CareCircleMemberField {
  label: string;
  value: string;
}

export interface CareCircleMemberInfoProps {
  title: string;
  fields: CareCircleMemberField[];
  onBack?: () => void;
}

/**
 * CareCircleMemberInfo displays a care circle member's profile information.
 */
export const CareCircleMemberInfo = ({
  title,
  fields,
  onBack,
}: CareCircleMemberInfoProps) => {
  return (
    <ModalPageTemplate onBack={onBack}>
      <PageTemplate
        maxWidth='sm'
        headerSlot={<PageHeader title={title} />}
        contentSlot={
          <Stack spacing={4}>
            {fields.map((field) => (
              <Stack key={field.label} spacing={1}>
                <Typography variant='subtitle2'>{field.label}</Typography>
                <Typography
                  variant='body1'
                  sx={{
                    color: 'text.secondary',
                  }}
                >
                  {field.value}
                </Typography>
              </Stack>
            ))}
          </Stack>
        }
      />
    </ModalPageTemplate>
  );
};

CareCircleMemberInfo.displayName = 'CareCircleMemberInfo';

export default CareCircleMemberInfo;
